"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_PERMISSIONS = void 0;
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("./permissions");
const COMMON_READ = [
    permissions_1.PERMISSIONS.PRODUCTS_READ,
    permissions_1.PERMISSIONS.CUSTOMERS_READ,
    permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_READ,
    permissions_1.PERMISSIONS.ORDERS_READ,
    permissions_1.PERMISSIONS.INVENTORY_READ,
    permissions_1.PERMISSIONS.TICKETS_READ,
    permissions_1.PERMISSIONS.FEEDBACK_READ,
    permissions_1.PERMISSIONS.REFUNDS_READ,
    permissions_1.PERMISSIONS.CONSULTATIONS_READ,
    permissions_1.PERMISSIONS.MEDICAL_HISTORY_READ,
];
exports.ROLE_PERMISSIONS = {
    [user_entity_1.UserRole.ADMIN]: [
        permissions_1.PERMISSIONS.DASHBOARD_READ,
        permissions_1.PERMISSIONS.REPORTS_READ,
        permissions_1.PERMISSIONS.USERS_MANAGE,
        permissions_1.PERMISSIONS.SETTINGS_MANAGE,
        ...COMMON_READ,
        permissions_1.PERMISSIONS.CUSTOMERS_CREATE,
        permissions_1.PERMISSIONS.CUSTOMERS_UPDATE,
        permissions_1.PERMISSIONS.CUSTOMER_ADDRESSES_MANAGE,
        permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_ALLOCATE,
        permissions_1.PERMISSIONS.ORDERS_MARK_PAYMENT,
        permissions_1.PERMISSIONS.ORDER_LINE_ITEMS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.PRODUCTS_CREATE,
        permissions_1.PERMISSIONS.PRODUCTS_UPDATE,
        permissions_1.PERMISSIONS.INVENTORY_UPSERT,
        permissions_1.PERMISSIONS.INVENTORY_ADJUST,
        permissions_1.PERMISSIONS.TICKETS_CREATE,
        permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.TICKETS_ESCALATE,
        permissions_1.PERMISSIONS.TICKETS_RESOLVE,
        permissions_1.PERMISSIONS.FEEDBACK_CREATE,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FORM,
        permissions_1.PERMISSIONS.FEEDBACK_MARK_FILLED,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FOLLOW_UP,
        permissions_1.PERMISSIONS.FEEDBACK_ADD_MANAGEMENT_REMARKS,
        permissions_1.PERMISSIONS.FEEDBACK_CLOSE,
        permissions_1.PERMISSIONS.REFUNDS_CREATE,
        permissions_1.PERMISSIONS.REFUNDS_TEAM_LEAD_REVIEW,
        permissions_1.PERMISSIONS.REFUNDS_MANAGEMENT_REVIEW,
        permissions_1.PERMISSIONS.REFUNDS_MARK_REFUNDED,
        permissions_1.PERMISSIONS.CONSULTATIONS_CREATE,
        permissions_1.PERMISSIONS.CONSULTATIONS_RESCHEDULE,
        permissions_1.PERMISSIONS.CONSULTATIONS_CANCEL,
        permissions_1.PERMISSIONS.CONSULTATIONS_MARK_WALK_IN,
        permissions_1.PERMISSIONS.CONSULTATIONS_CLOSE,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_UPLOAD,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_CREATE,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_DELETE,
    ],
    [user_entity_1.UserRole.CALL_CENTER]: [
        ...COMMON_READ,
        permissions_1.PERMISSIONS.CUSTOMERS_CREATE,
        permissions_1.PERMISSIONS.CUSTOMERS_UPDATE,
        permissions_1.PERMISSIONS.CUSTOMER_ADDRESSES_MANAGE,
        permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_ALLOCATE,
        permissions_1.PERMISSIONS.ORDERS_MARK_PAYMENT,
        permissions_1.PERMISSIONS.TICKETS_CREATE,
        permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.TICKETS_RESOLVE,
        permissions_1.PERMISSIONS.FEEDBACK_CREATE,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FORM,
        permissions_1.PERMISSIONS.FEEDBACK_MARK_FILLED,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FOLLOW_UP,
        permissions_1.PERMISSIONS.FEEDBACK_CLOSE,
        permissions_1.PERMISSIONS.REFUNDS_CREATE,
        permissions_1.PERMISSIONS.CONSULTATIONS_CREATE,
        permissions_1.PERMISSIONS.CONSULTATIONS_RESCHEDULE,
        permissions_1.PERMISSIONS.CONSULTATIONS_CANCEL,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_UPLOAD,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_CREATE,
    ],
    [user_entity_1.UserRole.LOGISTICS]: [
        permissions_1.PERMISSIONS.DASHBOARD_READ,
        permissions_1.PERMISSIONS.PRODUCTS_READ,
        permissions_1.PERMISSIONS.ORDERS_READ,
        permissions_1.PERMISSIONS.ORDERS_ALLOCATE,
        permissions_1.PERMISSIONS.ORDER_LINE_ITEMS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.INVENTORY_READ,
        permissions_1.PERMISSIONS.INVENTORY_ADJUST,
        permissions_1.PERMISSIONS.TICKETS_READ,
        permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.TICKETS_RESOLVE,
    ],
    [user_entity_1.UserRole.DOCTOR]: [
        permissions_1.PERMISSIONS.DASHBOARD_READ,
        permissions_1.PERMISSIONS.CUSTOMERS_READ,
        permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_READ,
        permissions_1.PERMISSIONS.PRODUCTS_READ, // needed for medicine search in consultation
        permissions_1.PERMISSIONS.ORDERS_READ, // needed to view generated orders
        permissions_1.PERMISSIONS.CONSULTATIONS_READ,
        permissions_1.PERMISSIONS.CONSULTATIONS_ADD_DOCTOR_NOTES,
        permissions_1.PERMISSIONS.CONSULTATIONS_MARK_WALK_IN,
        permissions_1.PERMISSIONS.CONSULTATIONS_CLOSE, // write prescription + close consultation
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_READ,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_SET_VALIDITY,
        permissions_1.PERMISSIONS.TICKETS_READ,
    ],
    [user_entity_1.UserRole.TEAM_LEAD]: [
        permissions_1.PERMISSIONS.DASHBOARD_READ,
        permissions_1.PERMISSIONS.REPORTS_READ,
        ...COMMON_READ,
        permissions_1.PERMISSIONS.CUSTOMERS_CREATE,
        permissions_1.PERMISSIONS.CUSTOMERS_UPDATE,
        permissions_1.PERMISSIONS.CUSTOMER_ADDRESSES_MANAGE,
        permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_CREATE,
        permissions_1.PERMISSIONS.ORDERS_ALLOCATE,
        permissions_1.PERMISSIONS.ORDERS_MARK_PAYMENT,
        permissions_1.PERMISSIONS.ORDER_LINE_ITEMS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.INVENTORY_ADJUST,
        permissions_1.PERMISSIONS.TICKETS_CREATE,
        permissions_1.PERMISSIONS.TICKETS_UPDATE_STATUS,
        permissions_1.PERMISSIONS.TICKETS_ESCALATE,
        permissions_1.PERMISSIONS.TICKETS_RESOLVE,
        permissions_1.PERMISSIONS.FEEDBACK_CREATE,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FORM,
        permissions_1.PERMISSIONS.FEEDBACK_MARK_FILLED,
        permissions_1.PERMISSIONS.FEEDBACK_SEND_FOLLOW_UP,
        permissions_1.PERMISSIONS.FEEDBACK_CLOSE,
        permissions_1.PERMISSIONS.REFUNDS_CREATE,
        permissions_1.PERMISSIONS.REFUNDS_TEAM_LEAD_REVIEW,
        permissions_1.PERMISSIONS.CONSULTATIONS_CREATE,
        permissions_1.PERMISSIONS.CONSULTATIONS_RESCHEDULE,
        permissions_1.PERMISSIONS.CONSULTATIONS_CANCEL,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_UPLOAD,
        permissions_1.PERMISSIONS.MEDICAL_HISTORY_CREATE,
    ],
    [user_entity_1.UserRole.MANAGEMENT]: [
        permissions_1.PERMISSIONS.DASHBOARD_READ,
        permissions_1.PERMISSIONS.REPORTS_READ,
        ...COMMON_READ,
        permissions_1.PERMISSIONS.TICKETS_ESCALATE,
        permissions_1.PERMISSIONS.FEEDBACK_ADD_MANAGEMENT_REMARKS,
        permissions_1.PERMISSIONS.REFUNDS_MANAGEMENT_REVIEW,
        permissions_1.PERMISSIONS.REFUNDS_MARK_REFUNDED,
    ],
};
